import React from 'react';
import { Grid, Modal } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

type Tprops = {
  customFormatAlertModal: boolean;
  setCustomFormatAlertModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CustomFormatAlertModal: React.FC<Tprops> = (props: Tprops) => {
  const { customFormatAlertModal, setCustomFormatAlertModal } = props;

  const classes = useStyles();

  return (
    <Modal
      open={customFormatAlertModal}
      onClose={() => setCustomFormatAlertModal(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.container}
    >
      <>
        <Grid container className={classes.subpaper}>
          <Grid item xs={12} className={classes.container}>
            <div style={{ textAlign: 'center', margin: '50px 0px' }}>
              <p style={{ fontSize: 18, marginTop: 18 }}>
                ２階層以下に明細を作成した場合は、
                <br />
                <span style={{ color: 'red' }}>CONOC標準書式</span>
                でPDFを作成します。
              </p>
            </div>
          </Grid>
          <CloseIcon
            style={{
              cursor: 'pointer',
              position: 'absolute',
              top: 16,
              right: 16
            }}
            fontSize='large'
            onClick={() => setCustomFormatAlertModal(false)}
          />
        </Grid>
        {/* 右上の×アイコン（モーダル閉じる） */}
      </>
    </Modal>
  );
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '70%',
      overflow: 'hidden'
    },
    subpaper: {
      // モーダル内部
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '40%',
      position: 'relative'
    },
    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    }
  })
);
